<template>
  <div class="monograph">
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="monographList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || monographList.length > 0">
        <ZzItem
          class="lv-list-item"
          v-for="item in monographList"
          :key="item.articleId"
          :cover="item.cover"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="
            item.authorList.split(',').length > 1
              ? `${item.authorList.split(',')[0]}等`
              : item.authorList.split(',')[0]
              ? item.authorList.split(',')[0]
              : ''
          "
          @click.native="toConcentrationDetails(item.articleId, item.articleType)"
        />
      </div>
      <noneList noneType="collect" v-else />
    </van-list>
  </div>
</template>

<script>
import ZzItem from "@/views/mobileView/components/listItem/zzItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "monograph",
  components: {
    ZzItem,
    noneList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      monographList: [],
    };
  },
  methods: {
    async getUserCollectThesisList(data) {
      this.loading = true;
      const resp = await this.$apis.userServe.getUserCollectThesisList({
        data,
        articleType: 2,
      });
      if (resp.resultCode == 200) {
        this.monographList = resp.data.list;
        this.finished = resp.data.list.length < 20 ? true : false;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    onLoad() {
      if (sessionStorage.getItem("token")) {
        this.getUserCollectThesisList();
      } else {
        this.finished = true;
        Toast("请先登录");
      }
    },
    toConcentrationDetails(id, type) {
      console.log(id,type);
      this.$router.push({
        name: "concentrationDetails",
        query: {
          id,
          type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.monograph {
  width: 100%;
  height: 100%;
  .lv-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .lv-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>